module.exports = __webpack_public_path__ + "static/media/to-text-success.5404593a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/to-text-success.png
// module id = 1889
// module chunks = 6